import { ReactNode } from 'react';
import cx from 'classnames';
import { QuestionMarkIcon } from './Icons/icons';
import { TextIcon } from './Icons/TextIcon';
import { Popover } from './Modals/Popover';

type SectionProps = {
    title: string;
    children: ReactNode | ReactNode[];
    helpText?: string;
    action?: ReactNode;
    className?: string;
};

export const Section = ({
    title,
    children,
    helpText,
    action,
    className,
}: SectionProps) => (
    <div className={cx('flex flex-col gap-6', className)}>
        <div className="flex flex-col gap-2">
            <div className="flex gap-3 flex-row items-center justify-between">
                <div className="flex items-center text-xl font-semibold">
                    <p>{title}</p>
                    {helpText && (
                        <Popover message={helpText}>
                            <TextIcon SVG={QuestionMarkIcon} />
                        </Popover>
                    )}
                </div>
                {action && <div className="flex-shrink-0">{action}</div>}
            </div>
            <hr className="border-woodyBrown border-1 opacity-30" />
        </div>
        {children}
    </div>
);
